<mat-expansion-panel class="task-card" [ngClass]="taskStatusClass.value">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="task-card-icon">{{ taskIconName.value }}</mat-icon>
            &nbsp;{{ task.subject }}
        </mat-panel-title>
        <mat-panel-description>
            {{ task.assignedToTeamId ? task.assignedToTeamName + ' - ' : ''
            }}{{ task.assignedToName }} - {{ task.isClosed ? 'completed' : 'due' }}
            {{ taskRelativeDate.value }}
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        @if (!task.isClosed) {
            <cb-display-value-new label="Due" [value]="task.dueDate | date: 'medium'">
            </cb-display-value-new>
        }
        @if (task.isMeeting) {
            <cb-display-value-new label="Location" [value]="task.location"></cb-display-value-new>
        }
        @if (task.comments && task.comments.length > 0) {
            <cb-display-value-new label="Comments" [value]="task.comments"></cb-display-value-new>
        }
        @if (task.isClosed) {
            <div class="flex-col">
                <cb-display-value-new
                    label="Outcome"
                    [value]="task.outcomeLabel"
                ></cb-display-value-new>
                <cb-display-value-new
                    label="Outcome Notes"
                    [value]="task.outcomeNotes"
                ></cb-display-value-new>
            </div>
        }
        <div class="flex-col">
            @if (task.createdDate && task.createdByName) {
                <cb-display-value-new label="Created">
                    {{ task.createdByName }} on {{ task.createdDate | date }}
                </cb-display-value-new>
            }
            @if (task.isClosed && task.closedDate && task.updatedByName) {
                <cb-display-value-new label="Completed">
                    {{ task.updatedByName }} on {{ task.closedDate | date }}
                </cb-display-value-new>
            }
        </div>
        @if (canComplete.value || canEdit.value) {
            <mat-divider class="divider"></mat-divider>
        }
        @if (canComplete.value || canEdit.value) {
            <div class="footer-buttons end-center flex-row">
                @if (canComplete.value) {
                    <button mat-stroked-button color="accent" (click)="openCompleteDialog()">
                        <mat-icon>done</mat-icon>
                        &nbsp;Complete
                    </button>
                }
                @if (canEdit.value) {
                    <button mat-stroked-button color="accent" (click)="openEditDialog()">
                        <mat-icon>mode_edit</mat-icon>
                        &nbsp;Edit
                    </button>
                }
            </div>
        }
    </div>
</mat-expansion-panel>
